module.exports = __webpack_public_path__ + "img/sorting.4452f24f.svg";